import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const RefreshIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M16.4629 9.21086H22L18.4716 5.68028C17.3357 4.54431 15.9207 3.72741 14.3689 3.3117C12.8172 2.89598 11.1833 2.8961 9.6316 3.31205C8.0799 3.728 6.66504 4.54511 5.52925 5.68124C4.39347 6.81737 3.5768 8.23249 3.16133 9.78432M2.00111 20.6312V15.0941M2.00111 15.0941H7.53824M2.00111 15.0941L5.52837 18.6247C6.66432 19.7606 8.0793 20.5775 9.63107 20.9932C11.1828 21.4089 12.8167 21.4088 14.3684 20.9929C15.9201 20.5769 17.335 19.7598 18.4707 18.6237C19.6065 17.4876 20.4232 16.0724 20.8387 14.5206M22 3.67373V9.20865"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

RefreshIcon.displayName = 'RefreshIcon';
